import { render, staticRenderFns } from "./TableAccidentDetails.vue?vue&type=template&id=35f552bd"
import script from "./TableAccidentDetails.vue?vue&type=script&lang=ts"
export * from "./TableAccidentDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports